import React, { Component } from 'react';
//import moment from 'moment';
import { Link } from 'react-router-dom';
import Table from './common/table';
import auth from '../services/authService';

const $ = require('jquery');
$.DataTable = require('datatables.net');

class SettingsTable extends Component {
  columns = [
    {
      path: 'usdToNaira',
      label: 'USD:NAIRA',
    },
    {
      path: 'btcToUsd',
      label: 'BTC:USD',
    },
    // {
    //   key: (bwallet) => `${bwallet._id}-s`,
    //   label: 'Info',
    //   content: (bwallet) => (
    //     <Link
    //       to={`/bwallet-types/${bwallet._id}`}
    //       className="btn btn-primary btn-sm"
    //     >
    //       View
    //     </Link>
    //   ),
    // },
  ];

  editColumn = {
    key: 'edit',
    label: 'Edit',
    content: (setting) => (
      <Link
        to={`/settings/edit/${setting._id}`}
        className="btn btn-custom btn-sm"
      >
        Edit
      </Link>
    ),
  };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    if (user && user.isAdmin) {
      this.columns.push(this.editColumn);
    }
  }

  componentDidMount() {
    $(document).ready(function () {
      $('#dataTable').DataTable();
    });
  }

  render() {
    const { settings, message } = this.props;
    return <Table columns={this.columns} data={settings} message={message} />;
  }
}

export default SettingsTable;
